import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/design-system.css'

const params = new URLSearchParams(window.location.search)
const wantsEmotionDemo = params.get('emotion-demo') === '1'
const emotionScreen = params.get('screen') || 'welcome'

if (wantsEmotionDemo && router.currentRoute.value.path !== '/emotion-demo') {
  router.replace({ path: '/emotion-demo', query: { screen: emotionScreen } }).catch(() => {})
}

createApp(App).use(router).mount('#app')
